// extracted by mini-css-extract-plugin
module.exports = {"Video":"video_Video__xRoFQ","VideoMobile":"video_VideoMobile__jROi9","Content":"video_Content__ZwgvL","Buttons":"video_Buttons__sEgv5","Full":"video_Full__9Afho"};